import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/home.vue'
import Blog from '@/components/blog.vue'
import About from '@/components/about.vue';
import Contact from '@/components/contact.vue';
import Rollercoin from '@/components/blog/rollercoin.vue';
import Sunflowerland from '@/components/blog/sunflowerland.vue';
import Web3 from '@/components/blog/web3.vue';
import Pinetwork from '@/components/blog/pinetwork.vue';
import Digital from '@/components/new/digital.vue';
import Intelligence from '@/components/new/intelligence.vue';


Vue.use(Router)

const routes = [
    {
        path: '/',
        name: 'home',
        component: Home
    },
    {
        path: '/blog',
        name: 'blog',
        component: Blog
    },
    {
        path: '/about',
        name: 'about',
        component: About
    },
    {
        path: '/contact',
        name: 'contact',
        component: Contact
    },
    {
        path: '/blog/rollercoin',
        name: 'rollercoin',
        component: Rollercoin
    },
    {
        path: '/blog/sunflowerland',
        name: 'sunflowerland',
        component: Sunflowerland
    },
    {
        path: '/blog/web3',
        name: 'web3',
        component: Web3
    },
    {
        path: '/blog/pinetwork',
        name: 'pinetwork',
        component: Pinetwork
    },
    {
        path: '/blog/digital',
        name: 'digital',
        component: Digital
    },
    {
        path: '/blog/intelligence',
        name: 'intelligence',
        component: Intelligence
    }

];

export default new Router({
    mode: 'history',
    routes
})